import geoData from'@tfx/common/mixins/geoData';export default{name:'footer-phones',mixins:[geoData]};